import { useState } from 'react';
import { uploadPaymentImages } from '../api/paymentImages';

interface UseUploadPaymentImagesResult {
  uploadImages: (files: File[]) => Promise<void>;
  isUploading: boolean;
  error: string | null;
}

/**
 * Hook for uploading payment images
 */
export function useUploadPaymentImages(
  jobId: number,
  paymentId: number,
  onSuccess?: () => void
): UseUploadPaymentImagesResult {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadImages = async (files: File[]) => {
    if (files.length === 0) return;

    setIsUploading(true);
    setError(null);

    try {
      await uploadPaymentImages(jobId, paymentId, files);

      // Call success callback
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      const errorMessage = 'Failed to upload images';
      setError(errorMessage);
      console.error('Error uploading payment images:', err);
      throw new Error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadImages,
    isUploading,
    error,
  };
}
